export default {
    // UtilPayment查询
    UtilPayment: "/utilPayment/show",
    // 列表点击Customer查询
    UtilPaymentCoustomer: "/utilPayment/customer",
    // UtilPayment新增
    UtilPaymentAdd: "/utilPayment/add",
    // Utilpayment删除
    UtilPaymentDel: "/utilPayment/delete",
    // utilpayment修改
    UtilPuymentUpdata: "/utilPayment/update",
    // utilpayment3个字段修改
    UtilPaymentUpdateBy: "/utilPayment/updateBy",
    // Utilpayment修改颜色
    UtilPaymentRecent: "/utilPayment/recent",
    // 月份表头
    Title: "/utilPayment/title",
    // compare修改
    Compare: "/utilPayment/compare",
    // gl 检索
    GetGLList: "/utilPayment/glAcct",
    UtilPaymentUpload: "/utilPayment/upload",
    // 修改回显
    UtilPaymentList: "/utilPayment/list",
    // util新增展示文件
    UtilPaymentUtilFile: "/utilPayment/utilFile",
    // util文件下载
    UtilPaymentExport: "/utilPayment/export",
};
